export default __webpack_public_path__ + "static/prs-dded1987e825605c7de3683e99285b25.png";